<template>
    <BRow v-if="cashes.length != 0">
        <BCol md="6" lg="4" v-for="cash in cashes" :key="cash.id">
            <BCard class="position-relative">
                <h1> <BLink :to="{ name: 'cash-view', params: { id: cash.id } }"> {{ cash.name }} </BLink> </h1>
                <div class="mt-2 mb-3" v-if="cash.status">
                    <span class="d-block text-muted"> Apertura: <b>{{ formatCurrency(cash.last_open_movement ? cash.last_open_movement.amount : 0) }}</b> </span>
                    <span class="d-block"> Último cierre: <b>{{ formatCurrency(cash.balance) }}</b> </span>
                    <span class="d-block"> Beneficios: <b>{{ formatCurrency(cash.profit) }}</b> </span>
                    <span class="d-block"> Saldo total contabilizado: <b>{{ formatCurrency(cash.total) }}</b> </span>
                </div>
                <div class="mt-2 mb-3" v-else>
                    <span class="d-block"> Último cierre: <b>{{ formatCurrency(cash.balance) }}</b> </span>
                </div>
                <div v-if="cash.status">
                    <BButton variant="primary" @click="enterCash(cash)" class="mr-1">Acceder a la caja</BButton>
                    <BButton variant="danger" @click="showModal('close', cash.id)">Cerrar caja</BButton>
                </div>
                <div v-else>
                    <BButton variant="primary" @click="showModal('open', cash.id)">Abrir caja</BButton>
                </div>
                <BDropdown variant="link" class="position-absolute absolute-dropdown" no-caret v-if="cash.status == true">
                    <template #button-content>
                        <FeatherIcon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                    </template>
                    <BDropdownItem @click="showModal('income', cash.id)">
                        <FeatherIcon icon="FileTextIcon" />
                        <span class="align-middle ml-50">Ingresar/Cobrar</span>
                    </BDropdownItem>
                    <BDropdownItem @click="showModal('withdraw', cash.id)">
                        <FeatherIcon icon="FileTextIcon" />
                        <span class="align-middle ml-50">Retirar/Pagar</span>
                    </BDropdownItem>
                </BDropdown>
            </BCard>
        </BCol>

        <!-- Modal abrir caja -->
        <BModal ref="openCashModal" centered hide-footer >
            <h2>Saldo actual: {{ cash.balance }}€</h2>
            <BForm @submit.prevent="openCash(cash)">
                <div class="mt-1 mb-3">
                    <label for="open_value">Saldo con el que se abrirá la caja</label>
                    <BFormInput v-model="cash.openValue" id="open_value" type="number" step="0.01" required />
                </div>
                <BRow>
                    <BCol>
                        <BButton type="submit" variant="primary">Abrir caja</BButton>
                        <BButton variant="secondary" @click="hideModal('open')">Cancelar</BButton>
                    </BCol>
                </BRow>
            </BForm>
        </BModal>

        <!-- Modal cerrar caja -->
        <BModal ref="closeCashModal" centered hide-footer>
            <h2>Saldo contabilizado: {{ cash.total }}€</h2>
            <BForm >
                <div class="mt-1 mb-3">
                    <div class="my-2">
                        <label for="actual_value">Saldo actual de la caja</label>
                        <BFormInput v-model="cash.actualValue" @input="updateProfit()" id="actual_value" type="number" step="0.01" required />
                    </div>
                    <div class="my-2">
                        <label for="upcommings">Beneficios / Retirada</label>
                        <BFormInput disabled v-model="profit" id="upcommings" type="number" step="0.01" required />
                    </div>
                    <div class="my-2">
                        <label for="close_value">Saldo con el que se va a cerrar la caja</label>
                        <BFormInput v-model="cash.closeValue" @input="updateProfit()" id="close_value"  type="number" step="0.01" required />
                    </div>
                </div>
                <BRow>
                    <BCol>
                        <BButton type="submit" variant="primary" @click.prevent="confirmWithdrawModal.show(); hideModal('close')">Cerrar caja</BButton>
                        <BButton variant="danger" @click="hideModal('close')">Cancelar</BButton>
                    </BCol>
                </BRow>
            </BForm>
        </BModal>

        <!-- Modal ingreso -->
        <BModal ref="incomeCashModal" centered hide-footer>
            <h2>Saldo actual: {{ cash.total + cash.balance }}€</h2>
            <BForm @submit.prevent="income(cash)">
                <div class="mt-1">
                    <label for="actual_value">Importe a ingresar en caja</label>
                    <BFormInput v-model="cash.incomeValue" id="incomeValue" type="number" step="0.01" required />
                </div>
                <div class="mt-1 mb-3">
                    <label for="actual_value">Observaciones</label>
                    <BFormInput v-model="cash.incomeObservation" id="incomeObservation" type="text" required />
                </div>
                <BRow>
                    <BCol>
                        <BButton type="submit" variant="primary">Ingresar</BButton>
                        <BButton variant="danger" @click="hideModal('income')">Cancelar</BButton>
                    </BCol>
                </BRow>
            </BForm>
        </BModal>

        <!-- Modal retirada -->
        <BModal ref="withdrawCashModal" centered hide-footer>
            <h2>Saldo actual: {{ cash.total + cash.balance }}€</h2>
            <BForm @submit.prevent="withdraw(cash)">
                <div class="mt-1 mb-3">
                    <label for="actual_value">Importe a retirar de caja</label>
                    <BFormInput v-model="cash.withdrawValue" id="withdrawValue" type="number" step="0.01" required />
                </div>

                <div class="mt-1 mb-3">
                    <label for="actual_value">Observaciones</label>
                    <BFormInput v-model="cash.withdrawObservation" id="withdrawObservation" type="text" required />
                </div>
                <BRow>
                    <BCol>
                        <BButton type="submit" variant="primary">Retirar</BButton>
                        <BButton variant="danger" @click="hideModal('withdraw')">Cancelar</BButton>
                    </BCol>
                </BRow>
            </BForm>
        </BModal>

        <!-- Modal confirmar dinero a retirar -->
        <BModal ref="confirmWithdrawModal" centered hide-footer>
            <div>
                <div class="pt-2 pb-2 text-center">
                    <feather-icon variant="info" icon="ChevronsRightIcon" size="80" class="mr-0 mr-sm-50 pb-2" />
                    <h4>Vas a retirar <b> {{ formatCurrency(profit) }} </b> </h4>
                    <h5>¿Es correcto?</h5>
                </div>

                <div>
                    <BButton variant="primary" @click.prevent="confirmCashCloseModal.show(); hideModal('confirmWithdraw')">Sí</BButton>
                    <BButton variant="danger" @click="hideModal('confirmWithdraw'); hideModal('close')">Cancelar</BButton>
                </div>
            </div>
        </BModal>

        <!-- Modal confirmar estás seguro -->
        <BModal ref="confirmCashCloseModal" centered hide-footer>
            <div>
                <div class="pt-2 pb-2 text-center">
                    <feather-icon variant="warning" icon="AlertCircleIcon" size="80" class="mr-0 mr-sm-50 pb-2" />
                    <h4>¿Estás seguro/a?</h4>
                    <h5>Una vez aceptado no podrás revertir los cambios</h5>
                </div>
                <div>
                    <BButton variant="primary" @click.prevent="closeCash(cash)">Sí</BButton>
                    <BButton variant="danger"  @click="hideModal('confirmClose'); hideModal('confirmWithdraw'); hideModal('close')">Cancelar</BButton>

                </div>
            </div>
        </BModal>
    </BRow>
    <BRow v-else>
        <BCol>
            <p>No hay ninguna caja disponible actualmente</p>
        </BCol>
    </BRow>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api';
import { BBadge, BButton, BCard, BCol, BDropdown, BDropdownItem, BForm, BFormInput, BLink, BModal, BRow } from 'bootstrap-vue';
import axios from '@axios';
import router from '@/router';
import popups from '@/hooks/popups';
import currency from '@/utils/currency';

export default {
    components: { BCard, BButton, BCol, BRow, BModal, BFormInput, BLink, BDropdown, BDropdownItem, BForm, BBadge },
    setup() {
        //& Variables
        const { errorToast } = popups()
        const cash = ref([]);
        const cashes = ref([]);
        const profit = ref(0);
        const openCashModal = ref('')
        const closeCashModal = ref('')
        const incomeCashModal = ref('')
        const withdrawCashModal = ref('')
        const { formatCurrency } = currency()

        const confirmWithdrawModal=ref('')
        const confirmCashCloseModal=ref('')
        //& Methods
        /**
         * Obtener cajas
         * @returns void
         */
        const fetchCashes = function(){
            axios.get("cashes").then(response => {
                cashes.value = response.data.cashes;
            });
        }

        /**
         * Abrir modal
         * @param {Cash} cash
         * @param {int} id
         * @returns void
         */
        const showModal = function(modal, id){
            if(modal == 'open') openCashModal.value.show()
            if(modal == 'close') closeCashModal.value.show()
            if(modal == 'income') incomeCashModal.value.show()
            if(modal == 'withdraw') withdrawCashModal.value.show()

            cash.value = cashes.value.find(cash => cash.id == id);
            cash.value.openValue = cash.value.group.initial_balance.toFixed(2)
            cash.value.closeValue = cash.value.group.initial_balance.toFixed(2)
            cash.value.actualValue = parseFloat(cash.value.total + cash.value.balance).toFixed(2)
            updateProfit()
        }

        /**
         * Cerrar modal
         * @param {string} cash
         * @returns void
         */
        const hideModal = function(modal){
            if(modal == 'open') openCashModal.value.hide()
            if(modal == 'close') closeCashModal.value.hide()
            if(modal == 'income') incomeCashModal.value.hide()
            if(modal == 'withdraw') withdrawCashModal.value.hide()
            if(modal == 'confirmWithdraw') confirmWithdrawModal.value.hide()
            if(modal == 'confirmClose') confirmCashCloseModal.value.hide()

        }

        /**
         * Abrir caja
         * @param {Cash} cash
         * @returns void
         */
        const openCash = function(cash){
            axios.post(`cash/open/${cash.id}`, cash).then(response => {
                if(response.data.success){
                    localStorage.setItem('cashSelected', JSON.stringify(cash))
                    router.push({ name: 'tpv' })
                }
            })
        }

        /**
         * Entrar en la caja
         * @param {Cash} cash
         * @returns void
         */
        const enterCash = function(cash){
            localStorage.setItem('cashSelected', JSON.stringify(cash))
            router.push({ name: 'tpv' })
        }

        /**
         * Cerrar caja
         * @param {Cash} cash 
         * @returns void
         */
        const closeCash = function(cash){
            axios.post(`cash/close/${cash.id}`, cash).then(response => {
                if(response.data.success){
                    fetchCashes()
                    hideModal('close')
                    hideModal('confirmWithdraw')
                    hideModal('confirmClose')

                    localStorage.removeItem('shoppingBasket')
                }
            })
        }

        /**
         * Realizar ingreso
         * @param {Cash} cash
         * @returns void
         */
        const income = function(cash){
            axios.post(`cash/income/${cash.id}`, cash).then(response => {
                if(response.data.success){
                    fetchCashes()
                    hideModal('income')
                }
            })
        }

        /**
         * Realizar retirada
         * @param {Cash} cash
         * @returns void
         */
        const withdraw = function(cash){
            if(((cash.total+cash.balance) - parseFloat(cash.withdrawValue)<0)){
                errorToast("Can't withdraw more money than there is in the cash register")
                return
            }
            axios.post(`cash/withdraw/${cash.id}`, cash).then(response =>  {
                if(response.data.success){
                    fetchCashes()
                    hideModal('withdraw')
                } else {
                    errorToast(response.data.msg)
                }
            })
        }

        fetchCashes()

        const updateProfit = function() {
            let res = parseFloat(cash.value.actualValue).toFixed(2) - parseFloat(cash.value.closeValue).toFixed(2)
            profit.value = res.toFixed(2);
        }

        return {
            withdrawCashModal,
            incomeCashModal,
            formatCurrency,
            closeCashModal,
            openCashModal,
            updateProfit,
            showModal,
            hideModal,
            closeCash,
            enterCash,
            openCash,
            withdraw,
            income,
            cashes,
            cash,
            profit,
            confirmWithdrawModal,
            confirmCashCloseModal
        };
    },
}
</script>

<style lang="scss">
.absolute-dropdown{
    top: 5px;
    right: 5px;
}
</style>
